<template>
  <div>
    <div class="container">
      <log-overview />

      <licence-overview />
    </div>
  </div>
</template>

<script>
import LogOverview from '@/components/dashboard/LogOverview.vue';
import LicenceOverview from '@/components/dashboard/LicenceOverview.vue';

export default {
  name: 'Dashboard',
  components: {
    logOverview: LogOverview,
    licenceOverview: LicenceOverview
  }
};
</script>

<style scoped>
.container {
  background-color: white;
  text-align: left;
}
</style>
